var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-table',{attrs:{"headers":_vm.headers,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }